import React, { useContext } from 'react'
import { CarOrderingContext } from "../../CarOrdering";
import Price from "./Price";

export default function TotalPrice() {
  const {
    order,
  } = useContext(CarOrderingContext)

  return (
    <Price price={order.price}/>
  )
}
